import grena from './grena.png';
import skull from './skull.png';
import sopr from './sopr.png';
import keanu from './keanu.png';
import zjdun from './zjdun.png';
import cucum from './cucumber.png';
import seven from './7ei.png';
import pstar from './pstar.png';

let gifts = [ {url: grena, name: 'grena', rusname: 'Святая граната'},
              {url: skull, name: 'skull', rusname: 'Череп орка'},
              {url: sopr, name: 'sopr', rusname: 'Простой учебник'},
              {url: keanu, name: 'keanu', rusname: 'Грустный Нео'},
              {url: zjdun, name: 'zjdun', rusname: 'Хохождун'},
              {url: cucum, name: 'cucum', rusname: 'Батлфилд Овервотч'},
              {url: seven, name: 'seven', rusname: 'Все очень плохо'},
              {url: pstar, name: 'pstar', rusname: 'И вот звёздочка ещё'},
];
export default gifts;


// WEBPACK FOOTER //
// ./src/img/gifts/gifts.js